<template>
  <div class="layout-body">
    <v-bread :breadList="breadList" class="custom-bread">
      <div slot="v-right">
      </div>
    </v-bread>

    <div class="layout-content news-list-content">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span>行业资讯列表</span>
        </div>
        <div class="news-list">
          <el-row v-for="item in tableData" :key="item.id">
            <el-col :span="17">
              <router-link :to="`/news-detail/${item.id}`">
                {{ item.title }}
              </router-link>
            </el-col>
            <el-col :span="7" class="time" align="right">
              {{ item.time }}
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pageData.pageNum"
                     :page-sizes="[10, 20, 100]"
                     :page-size="pageData.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="pageData.total"
                     class="pagination">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CourseApi from 'Api/newsApi';

export default {
  data() {
    return {
      breadList: [
        { name: '网站首页', url: '/' },
        { name: '行业资讯列表', url: '' },
      ],
      tableData: [],
      pageData: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },

  created() {
    this.getNewsList();
  },

  computed: {
  },

  methods: {
    getNewsList() {
      CourseApi.getNewsList({
        pageNum: this.pageData.pageNum,
        pageSize: this.pageData.pageSize,
      }, (response) => {
        this.tableData = response.data.content;
        this.pageData.pageNum = response.data.pageNum;
        this.pageData.pageSize = response.data.pageSize;
        this.pageData.total = response.data.total;
      });
    },

    handleCurrentChange(val) {
      this.pageData.pageNum = val;
      this.getNewsList();
    },

    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getNewsList();
    },
  },
};
</script>

<style lang="scss" scoped>
  .news-list-content {
    background: #F5F6F7;
    .news-list {
      margin-bottom: 15px;
      color: #7a7a7a;
      font-size: 14px;
      .el-row {
        padding: 12px 5px;
        border-bottom: 1px dashed #cccccc;
        &:hover {
          background: #F5F6F7;
        }
      }
      .time {
        color: #999999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/news/news-list.vue